"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _ref2 = _react.default.createElement("div", {
  className: "margin-right-3"
}, _react.default.createElement("strong", null, "Calico"), _react.default.createElement("br", null), "1170 Veterans Boulevard", _react.default.createElement("br", null), "South San Francisco, CA 94080");

var _ref3 = _react.default.createElement("br", null);

var _ref4 = _react.default.createElement("br", null);

var _ref5 = _react.default.createElement("a", {
  className: "margin-right-2 inline-block grey-l",
  href: "https://www.calicolabs.com/",
  rel: "noopener noreferrer",
  target: "_blank"
}, "calicolabs.com");

var _ref6 = _react.default.createElement("a", {
  className: "margin-right-2 inline-block grey-l",
  href: "https://www.calicolabs.com/privacy-policy/",
  rel: "noopener noreferrer",
  target: "_blank"
}, "Privacy Policy");

var _ref7 = _react.default.createElement("a", {
  className: "margin-right-2 inline-block grey-l",
  href: "https://www.calicolabs.com/code-of-conduct/",
  rel: "noopener noreferrer",
  target: "_blank"
}, "Code of Conduct");

var CalicoResearchFooter = function CalicoResearchFooter(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style;
  var year = new Date().getFullYear();
  return _react.default.createElement("footer", {
    className: (0, _classnames.default)('calico-research-footer', className),
    style: style
  }, children && _react.default.createElement("div", {
    className: "margin-bottom-3"
  }, children), _react.default.createElement("div", {
    classname: "flex-row margin-bottom-3"
  }, _ref2, _react.default.createElement("div", null, _ref3, _ref4, _react.default.createElement("span", {
    className: "margin-right-2 inline-block"
  }, "\xA9\xA0", year, " Calico"), _ref5, _ref6, _ref7)));
};

var _default = CalicoResearchFooter;
exports.default = _default;